// Configuration - Toggle visibility of badges
export const BADGE_CONFIG = {
  showIndexBadge: false,
  showTypeBadge: false,
  showSectionBadge: false,
  showStyleBadge: false,
  showFixedBadge: false,
};

export interface Recipient {
  name: string;
  role?: string;
}

export interface RecipientData {
  recipients?: Recipient[];
  bank?: string;
}

export interface Signatory {
  name: string;
  title: string;
}

export interface SignatureData {
  closing_text?: string;
  signatories?: Signatory[];
  on_behalf?: string;
}

export interface Advisor {
  item: string;
  firm: string;
}

export interface AdvisorsTableData {
  title?: string;
  intro?: string;
  advisors?: Advisor[];
}

export interface Contact {
  name: string;
  role: string;
  email: string;
  phone: string;
}

export interface ContactsTableData {
  title?: string;
  intro?: string;
  contacts?: Contact[];
}

export type ParagraphData =
  | string
  | RecipientData
  | SignatureData
  | AdvisorsTableData
  | ContactsTableData;

export interface Paragraph {
  type?: "markdown" | "recipients" | "signatures" | "advisors_table" | "contacts_table";
  data: ParagraphData;
  style?: string;
  section_id?: string;
  fixed?: boolean;
}

export interface DraftContentData {
  paragraphs: Paragraph[];
}

export interface ParagraphItemProps {
  paragraph: Paragraph;
  index: number;
  isExpanded: boolean;
  onToggle: () => void;
  projectId: string | undefined;
  docId: string | undefined;
  onToggleSelection: (paragraphId: number, isSelected: boolean) => void;
}
